<template>
  <validation-observer ref="dataForm">
    <b-row>
      <b-col md="12">
        <!-- .email -->
        <b-form-group
          :label="$t('users.password')"
          label-for="reset-password-new"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('users.password')"
            vid="Password"
            rules="required|password"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                id="reset-password-new"
                v-model="newItem.password"
                :type="password1FieldType"
                :state="errors.length > 0 ? false : null"
                class="form-control-merge"
                name="reset-password-new"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="password1ToggleIcon"
                  @click="togglePassword1Visibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <!-- .email -->
        <b-form-group
          label-for="reset-password-confirm"
          :label="$t('users.password_confirmation')"
          label-cols-md="3"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('users.password_confirmation')"
            rules="required|confirmed:Password"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                id="reset-password-confirm"
                v-model="newItem.password_confirmation"
                :type="password2FieldType"
                class="form-control-merge"
                :state="errors.length > 0 ? false : null"
                name="reset-password-confirm"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="password2ToggleIcon"
                  @click="togglePassword2Visibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/register-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  data() {
    return {
      newItem: {},

      password1FieldType: "password",
      password2FieldType: "password",
    };
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    async returnData() {
      const isValid = await this.$refs.dataForm.validate();
      if (!isValid) {
        return { valid: false };
      }
      return { valid: true, data: this.newItem };
    },
  },
};
</script>

<style>
</style>